import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { socials } from "../constants";
import logoImage from "../public/logoImage.png";
import logoImageDark from "../public/logoImageDark.png";
import {IoLogoYoutube} from "react-icons/io"
import {BsFacebook ,BsLinkedin ,BsInstagram} from "react-icons/bs"

import styles from "../styles/index";
import { fadeIn, staggerContainer } from "../utils/motion";
const Footer = () => {
  const { t } = useTranslation();
  return (
    <section className={`${styles.paddings}`}>
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        className={`${styles.innerWidth} py-8 relative `}
      >
        <div className="footer-gradient" />

        <motion.div
          variants={fadeIn("up", "tween", 0.3, 1)}
          initial="hidden"
          whileInView="show"
          className={` `}
        >
          <div className="mb-[50px] h-[2px] dark:border-white border-t border-Darktext opacity-20" />

          <div className="flex  justify-start md:justify-between flex-col md:flex-row gap-4">
            <div className=" flex ">
              <img
                src={logoImage}
                alt=""
                className="h-[36px] hidden dark:flex"
              />
              <img
                src={logoImageDark}
                alt=""
                className="h-[36px] dark:hidden flex"
              />{" "}
              <p className="font-extrabold self-center leading-[30px] text-[24px] ">
                TOURMAN
              </p>
            </div>
            <p className="font-normal text-[14px] dark:text-white text-Darktext dark:opacity-50">
              {t("footer")}
            </p>
            <div className=" flex   ">
                    <div className="text-[26px] lg:text-[29px] mb-2 mx-2 cursor-pointer "> <IoLogoYoutube/> </div>
                    <div className="text-[26px] lg:text-[29px] mb-2 mx-2 cursor-pointer"> <BsFacebook/> </div>
                    <div className="text-[26px] lg:text-[29px] mb-2 mx-2 cursor-pointer"> <BsLinkedin/> </div>
                    <div className="text-[26px] lg:text-[29px] mb-2 mx-2 cursor-pointer"><BsInstagram/> </div>
                </div>

          </div>
          <div></div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Footer;
